(function () {
  var s = window.mdCookieSettings || {};

  function customizeCookieBanner() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.dataset.mdCustomized) return;
    banner.dataset.mdCustomized = '1';

    // Bordure
    banner.style.border = s.borderWidth + 'px solid ' + s.borderColor;
    banner.style.borderRadius = s.borderRadius + 'px';

    // Alignement du texte
    var wrapper = banner.querySelector('.shopify-pc__banner__wrapper');
    if (wrapper) wrapper.style.textAlign = s.textCentered ? 'center' : 'left';

    var body = banner.querySelector('.shopify-pc__banner__body');
    if (body) body.style.textAlign = s.textCentered ? 'center' : 'left';

    // Logo à la place du titre
    var title = document.getElementById('shopify-pc__banner__body-title');
    if (title && s.logoUrl) {
      var logoWrapper = document.createElement('div');
      logoWrapper.className = 'md-cookie-logo';
      logoWrapper.innerHTML =
        '<a href="/">' +
          '<figure>' +
            '<img src="' + s.logoUrl + '" alt="logo">' +
          '</figure>' +
        '</a>';
      title.parentNode.replaceChild(logoWrapper, title);
    }

    // Séparateur entre texte et boutons
    var btns = banner.querySelector('.shopify-pc__banner__btns');
    if (btns) {
      var hr = document.createElement('hr');
      hr.className = 'md-cookie-divider';
      btns.parentNode.insertBefore(hr, btns);
    }

    // Bouton Gérer vos préférences
    var btnManage = document.getElementById('shopify-pc__banner__btn-manage-prefs');
    if (btnManage) {
      btnManage.style.backgroundColor = s.btnBg;
      btnManage.style.color = s.btnText;
      btnManage.style.borderColor = s.btnBg;
    }
  }

  var observer = new MutationObserver(function () {
    var banner = document.getElementById('shopify-pc__banner');
    if (banner && !banner.dataset.mdCustomized) {
      customizeCookieBanner();
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
